import * as constants from '../constants';

const initialState = {
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getCompositions.success: {
            return action.payload;
        }

        case constants.getCompositions.try:
        case constants.getCompositions.error: {
            return initialState;
        }

        default:
            return state;
    }
}
